"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export function PageViewTracker() {
    const pathname = usePathname()

    useEffect(() => {
        if (typeof window === "undefined") return

        const trackView = async () => {
            try {
                const fullPath = (pathname || "") + (window.location.search || "")

                await fetch("/api/analytics/page-view", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        path: fullPath,
                        referrer: document.referrer,
                    }),
                })
            } catch (error) {
                // Silently fail to not disrupt user experience
                console.error("Analytics error:", error)
            }
        }

        if (typeof window !== "undefined" && "requestIdleCallback" in window) {
            window.requestIdleCallback(() => {
                trackView();
            });
        } else {
            setTimeout(trackView, 100);
        }
    }, [pathname])

    return null
}
